import { useState } from "react";
import styles from "./ReviewerGate.module.css";

export default function ReviewerGate({ initial = "", onSubmit }) {
  const [name, setName] = useState(initial);

  function submit(e) {
    e.preventDefault();
    const clean = name.trim().replace(/\s+/g, " ").replaceAll("|", "/");
    if (clean) onSubmit(clean);
  }

  return (
    <div className={styles.overlay}>
      <form className={styles.card} onSubmit={submit} aria-labelledby="qa-gate-title">
        <p className={styles.kicker}>NSSC Treasure Hunt / QA</p>
        <h1 id="qa-gate-title" className={styles.title}>Who is checking?</h1>
        <p className={styles.copy}>
          Your name is attached to every check, comment and suggestion so the team knows who did what.
        </p>
        <input
          className={styles.input}
          value={name}
          maxLength={40}
          autoFocus
          autoComplete="name"
          placeholder="YOUR NAME"
          aria-label="Your name"
          onChange={(e) => setName(e.target.value)}
        />
        <button type="submit" className={styles.submit} disabled={!name.trim()}>
          Start reviewing →
        </button>
      </form>
    </div>
  );
}
